var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWifi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.974,
    height: 25.496,
    viewBox: "0 0 35.974 25.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-wifi",
    "data-name": "Icon feather-wifi",
    transform: "translate(2.117 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_128",
    "data-name": "Trac\\xE9 128",
    d: "M7.5,18.825a16.5,16.5,0,0,1,21.12,0",
    transform: "translate(-2.13 -7.504)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_129",
    "data-name": "Trac\\xE9 129",
    d: "M2.13,13.5a24,24,0,0,1,31.74,0",
    transform: "translate(-2.13 -7.504)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_130",
    "data-name": "Trac\\xE9 130",
    d: "M12.8,24.165a9,9,0,0,1,10.425,0",
    transform: "translate(-2.13 -7.504)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_131",
    "data-name": "Trac\\xE9 131",
    d: "M18,30h0",
    transform: "translate(-2.13 -7.504)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWifi);
export default __webpack_public_path__ + "static/media/icon-wifi.4309f6db3ffc27ad1237d3ff0f94b7a8.svg";
export { ForwardRef as ReactComponent };